import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { InboxItem } from 'src/api/inboxes';

export type InboxesContextType = {
  items: InboxItem[];
  isLoading: boolean;
  isError: boolean;
  setItems: Dispatch<SetStateAction<InboxItem[]>>;
};

export const InboxesContext = createContext<InboxesContextType | null>(null);
InboxesContext.displayName = 'InboxesContext';

export const useInboxesContext = () => {
  const context = useContext(InboxesContext);
  if (!context) {
    throw new Error(
      'useInboxesContext must be used within a InboxesContextProvider',
    );
  }
  return context;
};
